import vue from "../../../../main";

export default function(context) {
  let result = context.$store.dispatch("confirmDialog", {
    content: vue.$t("components.actions.delegationOrder.cancelConfirm.content"),
    title: vue.$t("components.actions.delegationOrder.cancelConfirm.title")
  });
  result.then(() => {
    //TODO KOMUNIKAT TRWA PRZETWARZANIE
    vue
      .axios({
        url: "delegation-order/cancel",
        data: { id: context.contextItemId },
        method: "POST"
      })
      .then(resp => {
        if (resp.data.status === "OK") {
          context.$store.dispatch("DelegationOrder/loadAllDelegationOrders");
        } else if (resp.data.status === "ERROR") {
          if (resp.data.message == "CanNotEdit") {
            context.$store.dispatch("alertDialog", {
              content: vue.$t("components.actions.operationNotAllowedNumberContinuityAlert.content"),
              title: vue.$t("components.actions.operationNotAllowedNumberContinuityAlert.title")
            });
          } else {
            alert("Wystapil nieoczekiwany blad, skontaktuj się z Administratotem");
            console.log(resp.data.message);
          }
        }
      })
      .catch(() => {
        //TODO obsluga bledow
      });
  });
}
